module.exports = __webpack_public_path__ + "img/flag-en.4c5e4143.svg";